"use client"

import { usePathname } from "next/navigation"
import { SearchBox } from "./index"
import { HttpTypes } from "@medusajs/types"
import { StoreFreeShippingPrice } from "@/types/shipping-option/http"

type ConditionalSearchBoxProps = {
  customer?: HttpTypes.StoreCustomer | null
  freeShippingPrices?: StoreFreeShippingPrice[]
}

export function ConditionalSearchBox({ 
  customer = null, 
  freeShippingPrices = [] 
}: ConditionalSearchBoxProps) {
  const pathname = usePathname()
  
  // Hide search box on search pages (matches pattern /[countryCode]/search)
  const isSearchPage = pathname.split('/').includes('search')
  
  if (isSearchPage) {
    return null
  }
  
  return <SearchBox customer={customer} freeShippingPrices={freeShippingPrices} />
} 